// core
import React from "react";

// components
import LModal from "../LModal/LModal";
import ModalHeader from "../ModalHeader/ModalHeader";
import DocumentLink from "../../Document/DocumentLink";

interface IAIAVitalityModal {
    isOpen: boolean;
    onClose: () => void;
}

const AIAVitalityModal: React.FC<IAIAVitalityModal> = (props) => {
    return (
        <React.Fragment>
            <LModal
                Header={() => (
                    <ModalHeader onClose={props.onClose} title="About AIA Vitality" />
                )}
                calcHeightMode="auto"
                width="wide"
                isOpen={props.isOpen}
                onClose={props.onClose}>
                {() => (
                    <React.Fragment>
                        <div className="logo-container">
                            <img
                                src="/images/svg/insurers/logo-aia-vitality.svg?v1"
                                alt="AIA Vitality"
                            />
                        </div>
                        <p className="intro">
                            AIA Vitality is an award-winning health and wellbeing program.
                            AIA Vitality&apos;s proven approach takes you on a journey to
                            better health. You will get to know your health, improve it
                            and enjoy the rewards for doing so.
                        </p>
                        <h4>How does AIA Vitality work?</h4>
                        <p>
                            AIA Vitality members earn AIA Vitality points by learning
                            about and improving the current state of their health in the
                            areas of physical, nutritional and mental wellbeing.
                        </p>
                        <DocumentLink
                            title="Program overview (PDF)"
                            thumbnailUrl="/images/brochures/AIA-Vitality-Program-Overview@2x.png"
                            documentUrl="/hosteddocuments/AIA-Vitality-Program-Overview.pdf"
                        />
                        <h4>What are the benefits?</h4>
                        <p>
                            New members start on Bronze status and as you make healthy
                            choices, like tracking your sleep or reaching your weekly
                            personalised physical activity targets, you earn AIA Vitality
                            points. The more points you earn, the higher your AIA Vitality
                            status and the greater the rewards.
                        </p>
                        <ul>
                            <li>
                                As an Airpoints Member, earn up to 300 Airpoints Dollars™
                                per membership year
                            </li>
                            <li>
                                Earn up to $260 in Active Benefits vouchers per membership
                                year
                            </li>
                            <li>
                                Earn a maximum of 4 Forme Spa &amp; Wellbeing vouchers at
                                a discounted rate of up to 50% per membership year
                            </li>
                            <li>
                                Earn up to 25% off Fitbit and Garmin devices, 25% off
                                JAGGAD performance apparel and up to 50% off HOYTS movie
                                tickets (limits apply).
                            </li>
                        </ul>
                        <DocumentLink
                            title="Points and rewards guide (PDF)"
                            thumbnailUrl="/images/brochures/AIA-Vitality-Points-And-Rewards-Guide@2x.png"
                            documentUrl="/hosteddocuments/AIA-Vitality-Points-And-Rewards-Guide.pdf"
                        />
                        <h4>Who is eligible for AIA Vitality?</h4>

                        <p>
                            Anyone with an eligible AIA insurance policy can take out an
                            AIA Vitality membership. Find out if you are eligible at&nbsp;
                            <a
                                href="https://www.aia.co.nz/en/aia-vitality.html"
                                target="_blank"
                                rel="noopener">
                                www.aia.co.nz
                            </a>
                        </p>
                        <h4>What does AIA Vitality cost?</h4>

                        <p>Members pay an $11.50 incl. GST membership fee per month.</p>

                        <h4>How do I get started?</h4>
                        <p>
                            Follow these easy steps to kick-start your AIA Vitality
                            membership:
                        </p>
                        <ol>
                            <li>
                                Apply for AIA Vitality membership within your AIA
                                insurance application
                            </li>
                            <li>
                                Once your AIA policy is issued your AIA Vitality
                                membership will be created
                            </li>
                            <li>
                                You will receive an activation email to activate your
                                membership
                            </li>
                            <li>Download the AIA Vitality App</li>
                            <li>Start your journey</li>
                        </ol>

                        <DocumentLink
                            title="Member fast start guide (PDF)"
                            thumbnailUrl="/images/brochures/AIA-Vitality-Member-Fast-Start-Guide@2x.png"
                            documentUrl="/hosteddocuments/AIA-Vitality-Member-Fast-Start-Guide.pdf"
                        />
                        <DocumentLink
                            title="Earning physical points (PDF)"
                            thumbnailUrl="/images/brochures/AIA-Vitality-Earning-Physical-Points@2x.png"
                            documentUrl="/hosteddocuments/AIA-Vitality-Earning-Physical-Points.pdf"
                        />
                        <h4>Is my AIA Vitality data safe and secure?</h4>

                        <p>
                            AIA take Information Security seriously and have processes and
                            secure systems in place to ensure your personal information is
                            safe.
                        </p>
                        <DocumentLink
                            title="Privacy flyer (PDF)"
                            thumbnailUrl="/images/brochures/AIA-Vitality-Privacy-Flyer@2x.png"
                            documentUrl="/hosteddocuments/AIA-Vitality-Privacy-Flyer.pdf"
                        />
                    </React.Fragment>
                )}
            </LModal>
        </React.Fragment>
    );
};

export default AIAVitalityModal;
